export interface CustomWindow extends Window {
  projectSettings: {
    apiUrl: string;
  };
}

declare const window: CustomWindow;

const settings = {
  apiUrl: window.projectSettings.apiUrl,
};

export default settings;
